import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "table table-bordered" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { class: "px-3 py-2" }, " Контрагент "),
    /*#__PURE__*/_createElementVNode("th", {
      class: "px-3 py-2",
      colspan: "2"
    }, " Дата ")
  ])
], -1)
const _hoisted_3 = { class: "px-3 py-2" }
const _hoisted_4 = { class: "px-3 py-2" }
const _hoisted_5 = { class: "px-3 py-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_select_ui = _resolveComponent("select-ui")!
  const _component_button_ui = _resolveComponent("button-ui")!
  const _component_modal_ui = _resolveComponent("modal-ui")!

  return (_openBlock(), _createBlock(_component_modal_ui, {
    id: _ctx.id,
    size: "modal-md",
    title: _ctx.state.title
  }, {
    default: _withCtx(() => [
      _createElementVNode("table", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("tbody", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.locos, (l, lInd) => {
            return (_openBlock(), _createElementBlock("tr", null, [
              _createElementVNode("td", _hoisted_3, [
                _createVNode(_component_select_ui, {
                  "item-key": "name",
                  options: _ctx.contractors,
                  placeholder: "Контрагент",
                  searchable: true,
                  values: [l.contractorCategoryId],
                  onOnSelected: (v) => _ctx.onContractorSelected(l, v)
                }, null, 8, ["options", "values", "onOnSelected"])
              ]),
              _createElementVNode("td", _hoisted_4, _toDisplayString(_ctx.moment(l.dt).locale('ru').format('D MMMM YYYY HH:mm')), 1),
              _createElementVNode("td", _hoisted_5, [
                _createVNode(_component_button_ui, {
                  "button-class": "btn-danger",
                  onClick: ($event: any) => (_ctx.deleteHandler(l, lInd))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" х ")
                  ]),
                  _: 2
                }, 1032, ["onClick"])
              ])
            ]))
          }), 256))
        ])
      ])
    ]),
    _: 1
  }, 8, ["id", "title"]))
}